/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-alert */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import {
  IdcardOutlined,
  ProfileOutlined,
  SolutionOutlined,
  UserOutlined,
} from '@ant-design/icons';
// import PropTypes from 'prop-types';
import { message, Select } from 'antd'; // message not needed when we removed proc groups from functionality
// import { Select } from 'antd';
// import axios from 'axios';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import { withRouter } from 'react-router-dom';
import {
  organizationForRegistration,
  getSamDataByCageAPI,
  getSamDataWithoutCageAPI,
} from '../../graphql/organizationDetails';
import history from '../../config/history';
import { isInvalidUSorCANZipCode, isCageCode } from '../../utils/validationUtils';
import { userEmailExists } from '../../graphql/users';
import { requestUser } from '../../graphql/updateUsers'; // import history from '../../config/history';
import {
  requestOrganization,
  // requestUpdateOrganization,
} from '../../graphql/organization';
import { organizationForRegister, getProcurementGroupList, getProcurementGroup, addProcurementGroup } from './graphql';
import { AssociationUrl } from '../../config/properties';
import { loginRoute } from '../../config/navigation/routes';

const { Option } = Select;

// import history from '../../config/history';

// import { addUserRoute, addToolingRoute } from '../../config/navigation/routes';

export default function RegistrationHOC(RegistrationPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.any.isRequired,
    };

    static initialState = {
      cageCode: null,
      emailAddress: null,
      validCage: false,
      step: 0,
      orgStep: 1,
      toastLevel: '',
      counter: 0,
      toastMessage: '',
      // userExists: false,
      orgExists: false,
      user: {},
      currentFlow: null,
      name: '',
      phone: '',
      selectedPoc: null,
      showToast: false,
      organization: { cntry: 'USA' },
      verifying: false,
      processing: false,
      loadingData: true,
      orgType: 'Industry',
      orgAdmin: false,
      submitted: false,
      steps: [],
      continueWithoutCage: false,
      organizationList: null,
      procurementGroupList: null,
      organizationNameList: [],
      industryAssociationsList: [],
      industryTypesList: [],
      naicsFoundryCodesList: {},
      // naicsCastingCodesList: {},
      naicsMachineCodesList: {},
      naicsForgingCodesList: {},
      naicsOthersCodesList: {},
      reasonRegistration: "",
      inputProcGrp: "",
      finalSubmit: undefined,
      registeredUserId: null,
      registeredUserEmail: null,
    };

    state = WrappedComponent.initialState;

    // update state with organizationList, procurementGroupList, and organizationNameList
    async componentDidMount() {
      const listOfOrgNames = [];

      let res = await organizationForRegister('requested');
      if (!res) {
        res = {};
      }
      let res1 = await organizationForRegister('approved');
      if (!res1) {
        res1 = {};
      }
      const orgList = sortBy([...res1, ...res], 'name');

      const uniqueOrgs = uniqBy(orgList, 'cageCode');

      /* eslint-disable consistent-return */
      /* eslint-disable array-callback-return */
      const arr = uniqueOrgs.map(organization => {
        if (!organization.name || !organization.cageCode) {
          return;
        }
        // return 'here';
        if (organization.cageCode !== 'O0000') {
          listOfOrgNames.push(
            organization.name.replace(/[^A-Z0-9]/gi, '').toLowerCase(),
          );
          return (
            <Option key={organization.cageCode} value={organization.cageCode}>
              {organization.name}
            </Option>
          );
        }
        // /  return <Option />;
      });

      let arrProcGrps = null;
      await getProcurementGroupList()
        .then((resp) => {
          arrProcGrps = resp.getProcurementGroupList.procurementGroupsList.map(procurementGroup => (
            <Option key={procurementGroup.cage} value={procurementGroup.cage} >
              {procurementGroup.description}
            </Option>
          )
          );
        }).catch((err) => {
          console.error({ msg: 'Error Unable to get RFQ Groups data from DB2!' }, err);
        });

      this.setState({
        organizationList: new Set(arr),
        procurementGroupList: new Set(arrProcGrps),
        organizationNameList: listOfOrgNames,
      });

      // Load industry associations and other lists on mount so they're always available
      await this._getOrgDetailsLists();
    }

    componentDidUpdate() {
      if (this.props.auth && this.props.auth.id) {
        history.push('/')
      }
    }

    _onError = (toastLevel, toastMessage) => {
      this.setState(
        {
          toastLevel,
          toastMessage,
          showToast: true,
          verifying: false,
          counter: (this.state.counter += 1),
        },
        () => {
          setTimeout(() => this.setState({ showToast: false }), 3000);
        },
      );
    };

    // is passed to <Registration> in props but not used.
    _changeOrg = e => {
      this.setState({
        orgType: e.target.value.toLowerCase(),
      });
    };

    _onOrganizationChange = e => {
      const org = {};

      if (typeof e === 'string') {
        org.state = e;
      } else {
        org[e.target.name] = e.target.value;
      }
      this.setState(
        {
          organization: { ...this.state.organization, ...org },
        },
      );
    };

    _onCountryChange = e => {
      const org = {};
      org.cntry = e;
      org.state = null;
      this.setState(prevState => ({
        organization: {
          ...prevState.organization,
          ...org
        }
      }));
    };

    putUserinDB = async (role, orgID, cageCode = null) => {

      const updateUserObj = {
        role,
        name: this.state.name,
        email: this.state.emailAddress ? this.state.emailAddress.toLowerCase() : this.state.emailAddress,
        phoneNumber: this.state.phone || "",
        faxNumber: "",
        organizationId: orgID,
        cageCode: cageCode || this.state.cageCode,
        id: this.state.user.id,
        // samGroup: this.state.selectedPoc,
      };
      console.log("updateUserObj", updateUserObj);
      // let response;
      // if (userExists) {
      //   response = await updateUser(updateUserObj);
      //   // dispatch the email function right here this
      //   return response;
      // }
      const response = await requestUser(updateUserObj); //

      return response.data;


    };

    createOrginDB = async org => {
      if (this.state.cageCode) {
        org.cageCode = this.state.cageCode.toUpperCase();
      }

      org.organizationType =
        this.state.orgType === 'Industry' ? 'common' : this.state.orgType;
      org.iconStatus = "requested";
      const response = await requestOrganization(org);
      return { id: response.requestOrganization.id, cage: response.requestOrganization.cageCode };
    };

    // updateOrginDB = async org => {
    //   org.organizationType =
    //     this.state.orgType === 'Industry' ? 'common' : this.state.orgType;

    //   await requestUpdateOrganization(org);
    // };

    _setRegistatrationFlow = e => {
      this.setState({
        currentFlow: e.target.value,
      });
      switch (e.target.value) {
        case 'new':
          this.setState({
            steps: [
              {
                title: 'cage',
                content: 'Last-content',
                icon: <IdcardOutlined />,
              },
              {
                title: 'User',
                content: 'Second-content',
                icon: <UserOutlined />,
              },
              {
                title: 'Organization',
                content: 'Last-content',
                icon: <ProfileOutlined />,
              },
              {
                title: 'Review',
                content: 'Last-content',
                icon: <SolutionOutlined />,
              },
            ],
          });
          break;
        case 'industry':
          this.setState({
            steps: [
              {
                title: 'Organization',
                content: 'Last-content',
                icon: <ProfileOutlined />,
              },
              {
                title: 'User',
                content: 'Second-content',
                icon: <UserOutlined />,
              },
              {
                title: 'Review',
                content: 'Last-content',
                icon: <SolutionOutlined />,
              },
            ],
          });
          break;

        case 'gov':
          this.setState({
            steps: [
              {
                title: 'RFQ Group',
                content: 'Last-content',
                icon: <ProfileOutlined />,
              },
              {
                title: 'User',
                content: 'Second-content',
                icon: <UserOutlined />,
              },
              {
                title: 'Review',
                content: 'Last-content',
                icon: <SolutionOutlined />,
              },
            ],
            orgType: 'government',
            cageCode: 'OG000',
          });
          break;

        default:
          break;
      }
    };

    _OnFoundOrganizationChange = async value => {

      this.setState({
        cageCode: value,
      });
    };

    _finalizeSubmit = async () => {
      try {

        if (!this.state.submitted) {
          this.setState({
            submitted: true,
          });

          // Proceed with normal registration flow
          await this._completeRegistration();

        }
      } catch (e) {

        this.setState({
          finalSubmit: "failure",
          submitted: false
        });
      }
    };

    _completeRegistration = async () => {
      try {
        try { delete this.state.organization.governmentBusiness; }
        catch (unused) { /* continue regardless of error */ }
        try { delete this.state.organization.altGvernmentBusiness; }
        catch (unused) { /* continue regardless of error */ }
        try { delete this.state.organization.electronicBusiness; }
        catch (unused) { /* continue regardless of error */ }
        try { delete this.state.organization.altElectronicBusiness; }
        catch (unused) { /* continue regardless of error */ }
        try { delete this.state.organization.pastPerformance; }
        catch (unused) { /* continue regardless of error */ }
        try { delete this.state.organization.altPastPerformance; }
        catch (unused) { /* continue regardless of error */ }

        let orgID = this.state.organization.id;
        let orgCageCode = this.state.cage;
        let createdOrganization = false;

        if (!this.state.orgExists) {
          createdOrganization = true;
          const organization = this.state.organization
          organization.pointOfContact = this.state.name;
          organization.email = this.state.emailAddress ? this.state.emailAddress.toLowerCase() : this.state.emailAddress;
          organization.phoneNumber = this.state.phone;

          if (this.state.cageCode === 'OG000') {
            const description = this.state.organization.name
            const modifiedBy = this.state.emailAddress ? this.state.emailAddress.toLowerCase() : this.state.emailAddress
            await addProcurementGroup(description, modifiedBy)
              .then((resp) => {
                organization.cageCode = resp.addProcurementGroup.cage
                this.state.cageCode = resp.addProcurementGroup.cage;
              }).catch((err) => {
                console.error({ msg: 'Error Unable to add RFQ Group data to DB2!' }, err);
              });
          }
          const createdOrg = await this.createOrginDB(organization);
          orgID = createdOrg.id;
          orgCageCode = createdOrg.cage;
          console.log("createdOrg", createdOrg);
        }

        // Create user
        let userResponse;
        if (createdOrganization) {
          console.log("option 1 - creating admin user");
          userResponse = await this.putUserinDB('admin', orgID, orgCageCode);
        } else {
          console.log("option 2 - creating regular user");
          userResponse = await this.putUserinDB('user', orgID, orgCageCode);
        }

        // Get the userId from the response
        const userId = (userResponse && userResponse.requestUser && userResponse.requestUser.id)
          || (userResponse && userResponse.id)
          || this.state.user.id;
        const userEmail = this.state.emailAddress ? this.state.emailAddress.toLowerCase() : this.state.emailAddress;

        this.setState({
          finalSubmit: "success",
          registeredUserId: userId,
          registeredUserEmail: userEmail,
        });
      } catch (error) {
        console.error('Error completing registration:', error);
        this.setState({
          finalSubmit: "failure",
          submitted: false
        });
      }
    };

    closeModalFailedRegistration = () => {
      this.setState({
        finalSubmit: undefined,
      });
    }

    _onChange = e => {
      // alert(e.target.type);
      let value = e.target.value;
      if (e.target.type === 'checkbox') {
        value = e.target.checked;
      }
      const name = e.target.name;

      // Normalize email addresses to lowercase when they're entered
      if (name === 'emailAddress' && value) {
        console.log(`Normalizing email from ${value} to ${value.toLowerCase()}`);
        value = value.toLowerCase();
      }

      if (name === "continueWithoutRFQ" && value) {
        this.setState({
          cageCode: "O0000",
          orgType: 'government'  // Set orgType to 'gov' when continuing without RFQ
        });
      } else if (name === "continueWithoutRFQ" && !value) {
        this.setState({
          cageCode: "OG000",
          orgType: 'government'  // Keep orgType as 'gov' when not continuing without RFQ
        });
      }
      this.setState({
        [name]: value,
      });

    };

    _onProcurementGroupChange = async value => {
      if (value === undefined) {
        value = "OG000"
      }
      this.setState({
        cageCode: value,
      });
    };

    _onMultiSelectOrganization = (name, value) => {
      this.setState(prevState => ({
        ...prevState,
        organization: {
          ...prevState.organization,
          [name]: value
        }
      }));
      if (name === "industryType") {
        // const elem = document.getElementById("reasonRegistration")
        // if (value.includes("Other")) {
        //   elem.style.display = "flex";
        // }
        // else {
        //   elem.style.display = "none";
        // }
        if (value.some(el => el !== "Other") && value.includes("Other")) {
          const newValue = value.filter(item => item !== "Other")
          this.setState(prevState => ({
            ...prevState,
            organization: {
              ...prevState.organization,
              industryType: newValue
            }
          }));
        }
        if (value.some(el => el !== "Other")) {
          try {
            const el = document.getElementById("Other");
            el.style.display = "none";
          }
          catch (unused) {/* continue regardless of error */ }

        }
        else {
          try {
            const el = document.getElementById("Other")
            el.style.display = "flex";

          }
          catch (unused) {/* continue regardless of error */ }
        }
      }
    };


    _verifyEmail = email => {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    };

    _validateUserName = name => {
      const nameRegex = /[\w\-'\s]+/;
      return name.trim()
        ? nameRegex.test(name)
          ? 'Not a valid name'
          : undefined
        : undefined;
    };

    _verifyNumber = phone => {
      if (!phone) return undefined;
      const phoneNumberRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
      return phoneNumberRegex.test(phone)
        ? 'Must be a number in the format xxx-xxx-xxxx'
        : undefined;
    };

    _onCancel = (increment = "step") => {
      if (this.state.processing) return
      this.setState({
        processing: true,
      }, async () => {
        if (increment === "orgStep" && this.state.orgStep > 1) {
          this.setState(prevState => ({
            orgStep: prevState.orgStep - 1
          }));
          this.setState({ processing: false });
          return;
        }
        if (this.state.step === 0) {
          this.setState({ processing: false });
          history.push('/');
        }
        else if (this.state.step === 2) {
          this.setState({
            continueWithoutCage: false,
            step: 1,
            emailAddress: null,
            name: null,
            phone: null,
            organization: { cntry: 'USA' },
            selectedPoc: null,
            reasonRegistration: null,
          });
          //   if (this.state.currentFlow !== "gov-with-procurement") {
          //     this.setState({
          //       cageCode: undefined,

          //     });
          // }
          // if (this.state.currentFlow === "gov") {
          //   this.setState({
          //     cageCode: "OG000",
          //     inputProcGrp: "",
          //   });
          // }
        }

        else if (this.state.step === 1) {
          this.setState({
            cageCode: null,
            emailAddress: null,
            step: 0,
            toastLevel: '',
            counter: 0,
            toastMessage: '',
            // userExists: false,
            orgExists: false,
            user: {},
            currentFlow: undefined,
            name: '',
            phone: '',
            showToast: false,
            organization: { cntry: 'USA' },
            verifying: false,
            orgType: 'Industry',
            orgAdmin: false,
            submitted: false,
            steps: [],
            continueWithoutCage: false,
            continueWithoutRFQ: false,
            selectedPoc: null,
            reasonRegistration: null,
            inputProcGrp: "",
          });
        }
        else {
          this.setState(prevState => ({
            step: prevState.step - 1
          }));
        }
        this.setState({ processing: false });
      });
    };

    _handleOk = () => {
      // If registration was successful (after policy agreement), redirect to login
      if (this.state.finalSubmit === "success") {
        this.setState({
          finalSubmit: undefined,
          registeredUserId: null,
          registeredUserEmail: null,
        });
        history.push(loginRoute);
      } else {
        // Otherwise, just reset counter (for other modals)
        this.setState({
          counter: 0,
        });
      }
    };

    _verifyCage = async (skipValidation = false) => {

      if (this.state.cageCode) {
        const response = await organizationForRegistration(
          this.state.cageCode.toUpperCase().replace(/\s+/g, ''),
        );
        const organization = response.organizationInDB;

        if (organization) {
          this.setState({
            orgExists: true,
          });

          if (skipValidation === false) {
            if (
              organization.iconStatus === 'approved' ||
              organization.iconStatus === 'requested'
            ) {
              this._onError('danger', 'This CAGE has already been registered. To add users to an existing organization, go back and select Industry User.');
              return 'error';
            }
            // if (
            //   !organization.iconStatus ||
            //   organization.iconStatus === 'legacy' ||
            //   organization.iconStatus === undefined
            // ) 
            this._onError('danger', 'Organization exists but is not active, contact support Email: support@nffs.org or support@iconportal.com to activate this account.');
            return 'error';


          }
          Object.keys(organization).forEach(
            key => organization[key] == null && delete organization[key],
          );
        } else {
          this.setState({
            orgExists: false,
          });
        }

        const SAMS = await getSamDataByCageAPI(this.state.cageCode.toUpperCase());

        // Log SAM API response for debugging
        if (SAMS === null) {
          console.warn('SAM API returned null for CAGE code:', this.state.cageCode.toUpperCase());
        } else if (!SAMS.organizationSamDataByCage) {
          console.warn('SAM API response missing organizationSamDataByCage for CAGE code:', this.state.cageCode.toUpperCase(), SAMS);
        } else if (!SAMS.organizationSamDataByCage.org) {
          console.warn('SAM API response missing org data for CAGE code:', this.state.cageCode.toUpperCase(), 'organizationSamDataByCage:', SAMS.organizationSamDataByCage);
        }

        if (SAMS !== null && !!SAMS.organizationSamDataByCage && SAMS.organizationSamDataByCage !== null && SAMS.organizationSamDataByCage.org) {
          // Only update lists if they exist in the CAGE data, otherwise preserve existing lists
          const updateData = {
            // phone: SAMS.organizationSamDataByCage.phone,
            // emailAddress: SAMS.organizationSamDataByCage.emailAddress,
            // name: SAMS.organizationSamDataByCage.name,
            verifying: false,
            organization: { ...SAMS.organizationSamDataByCage.org, ...organization },
          };

          // Only update lists if they exist and are not empty
          if (SAMS.organizationSamDataByCage.industryAssociationsList &&
            Array.isArray(SAMS.organizationSamDataByCage.industryAssociationsList) &&
            SAMS.organizationSamDataByCage.industryAssociationsList.length > 0) {
            updateData.industryAssociationsList = SAMS.organizationSamDataByCage.industryAssociationsList;
          }

          if (SAMS.organizationSamDataByCage.naicsFoundryCodesList &&
            Object.keys(SAMS.organizationSamDataByCage.naicsFoundryCodesList).length > 0) {
            updateData.naicsFoundryCodesList = SAMS.organizationSamDataByCage.naicsFoundryCodesList;
          }

          if (SAMS.organizationSamDataByCage.naicsMachineCodesList &&
            Object.keys(SAMS.organizationSamDataByCage.naicsMachineCodesList).length > 0) {
            updateData.naicsMachineCodesList = SAMS.organizationSamDataByCage.naicsMachineCodesList;
          }

          if (SAMS.organizationSamDataByCage.naicsForgingCodesList &&
            Object.keys(SAMS.organizationSamDataByCage.naicsForgingCodesList).length > 0) {
            updateData.naicsForgingCodesList = SAMS.organizationSamDataByCage.naicsForgingCodesList;
          }

          if (SAMS.organizationSamDataByCage.naicsOthersCodesList &&
            Object.keys(SAMS.organizationSamDataByCage.naicsOthersCodesList).length > 0) {
            updateData.naicsOthersCodesList = SAMS.organizationSamDataByCage.naicsOthersCodesList;
          }

          if (SAMS.organizationSamDataByCage.industryTypesList &&
            Array.isArray(SAMS.organizationSamDataByCage.industryTypesList) &&
            SAMS.organizationSamDataByCage.industryTypesList.length > 0) {
            updateData.industryTypesList = SAMS.organizationSamDataByCage.industryTypesList;
          }

          this.setState(updateData);
        }
        else {
          this.setState({
            verifying: false,
            organization: { ...organization },
          });

        }

        if (!this.state.cageCode.startsWith('OG')) {
          if (!SAMS || !SAMS.organizationSamDataByCage || !SAMS.organizationSamDataByCage.org) {
            if (!organization) {
              // Check if CAGE code format is valid - if so, it might be an API issue rather than invalid code
              const cageCodeValidation = isCageCode(this.state.cageCode.toUpperCase());
              if (cageCodeValidation === undefined) {
                // CAGE code format is valid, but API call failed - likely a temporary API issue
                this._onError('danger', 'Unable to verify CAGE code. The CAGE code format is valid, but we could not retrieve data from SAM.gov. Please try again or contact support if the issue persists.');
              } else {
                // CAGE code format is invalid
                this._onError('danger', 'Invalid Cage Code');
              }
              return 'error';
            }
          } else if (SAMS.organizationSamDataByCage.org.cntry !== 'USA' && SAMS.organizationSamDataByCage.org.cntry !== 'CAN') {
            this._onError('danger', 'ICON only accepts US and Canadian CAGES that are valid!');
            return 'error';
          }
        }
        else if (this.state.cageCode.startsWith('OG') && this.state.cageCode !== 'OG000') {
          await getProcurementGroup(this.state.cageCode.toUpperCase())
            .then((res) => {
              // this.setState({
              //   organization: {
              //     name: res.getProcurementGroup.description,
              //     cntry: 'USA',
              //     iconStatus: 'approved',
              //     cageCode: this.state.cageCode.toUpperCase(),
              //     // id: resp.organizationInDB.id,
              //   }
              // })
              this.setState(prevState => ({
                organization: {
                  ...prevState.organization,
                  name: res.getProcurementGroup.description,
                  cntry: 'USA',
                  iconStatus: 'requested',
                  cageCode: this.state.cageCode.toUpperCase(),
                }
              }))

            }).catch((err) => {
              console.error({ msg: 'Error Unable to get RFQ Group by cage from DB2!' }, err);
              this._onError('danger', 'Error Unable to get RFQ Group by cage from DB2!');
              return 'error';
            });
          // return 'success'
        } else
          // let foundProcGrp = false;
          if (this.state.step === 1) {
            const arrProcGrps = Array.from(this.state.procurementGroupList);
            for (let i = 0; i < arrProcGrps.length; i++) {
              if (document.getElementById("inputProcGrp").value === arrProcGrps[i].props.children) {
                message.warn("This group exists, please select it from the RFQ Group dropdown list.", 6);
                // foundProcGrp = true;
                this.state.step = 0;
                break;

              }

              this.setState({
                organization: {
                  name: document.getElementById("inputProcGrp").value,
                  cntry: 'USA',
                  iconStatus: 'requested',
                  // dqEnabled: false,
                  //  approvalDate: new Date().toISOString().slice(0, 10),                 
                }
              })

            }
          }

      }
      return 'success';
    };

    _verifyUser = async (notSamPoc = true) => {
      if (!notSamPoc) {
        if (!this.state.selectedPoc) {
          this._onError('danger', 'Please select a valid Point of Contact');
          this.setState({
            verifying: false,
          });
          return 'error';
        }
        return 'success';
      }

      if (!this.state.name) {
        this._onError('danger', 'Please enter a your name');
        this.setState({
          verifying: false,
        });
        return 'error';
      }

      const validEmail = this._verifyEmail(this.state.emailAddress);
      if (!validEmail) {
        this._onError('danger', 'Please enter a valid Email');
        this.setState({
          verifying: false,
        });
        return 'error';
      }

      // Add .mil email validation for government users
      if (this.state.orgType === 'government' || this.state.orgType === 'gov-with-procurement') {
        const isGovernmentEmail = this.state.emailAddress.toLowerCase().endsWith('.mil');
        if (!isGovernmentEmail) {
          this._onError('danger', 'Government users must register with a .mil email address');
          this.setState({
            verifying: false,
          });
          return 'error';
        }
      }

      let user = await userEmailExists(
        this.state.emailAddress,
      );
      if (user) {
        user = user.userByEmailStatus;
      }
      if (user) {
        if (
          user.iconStatus === 'approved' ||
          user.iconStatus === 'requested' ||
          user.iconStatus === 'legacy'
        ) {
          this._onError('warning', 'This Email has already registered');
          return 'error';
        }
      }

      const validNumber = this._verifyNumber(this.state.phone);

      if (!validNumber) {
        this._onError('danger', 'Please Enter a valid Phone Number in the format (xxx) xxx-xxxx');
        return 'error';
      }

      return 'success';
    };

    _verifySelectedOrg = async () => {
      if (!this.state.cageCode) {
        this._onError('danger', 'Please select an organization');
        this.setState({
          verifying: false,
        });
        return 'error';
      }
      const response = await organizationForRegistration(
        this.state.cageCode.toUpperCase().replace(/\s+/g, ''),
      );
      const organization = response.organizationInDB;

      if (!organization) {
        this._onError('danger', 'This organization is not registered with ICON. Please select an organization from the list');
        this.setState({
          verifying: false,
        });
        return 'error';
      }
      return 'success';
    };





    _verifyOrgFields = () => {


      let statusOfSuccess = 'success';
      const requiredFields = [
        'name',
        'address1',
        'city',
        'state',
        'zipCode',
        'cntry',
        'websiteUrl',
      ];

      const currentFields = Object.keys(this.state.organization);

      requiredFields.some(requiredField => {
        if (currentFields.indexOf(requiredField) === -1) {
          this._onError('warning', 'Please Enter remaining required fields');
          statusOfSuccess = 'error';
          return true;
        }
      });

      requiredFields.some(requiredField => {
        if (this.state.organization[requiredField] === "" || this.state.organization[requiredField] === null) {
          this._onError('warning', 'Please Enter remaining required fields');
          statusOfSuccess = 'error';
          return true;
        }
      });


      if (this.state.organization && this.state.organization.name) {
        let name = this.state.organization.name;
        name = name.replace(/[^A-Z0-9]/gi, '').toLowerCase();
        const exsistingIndex = this.state.organizationNameList.indexOf(name);
        if (exsistingIndex !== -1) {
          this._onError(
            'danger',
            'This Organization already exists please go through industry User Selection',
          );
          return 'error';
        }
      }


      const invalidZipcode = isInvalidUSorCANZipCode(this.state.organization.zipCode, this.state.organization.cntry);

      if (invalidZipcode) {
        this._onError('danger', invalidZipcode);
        return 'error';
      }

      return statusOfSuccess;
    };

    _verifyOrgDescription = () => {
      let statusOfSuccess = 'success';

      if (!this.state.organization.industryType || this.state.organization.industryType.length === 0) {
        this._onError('warning', 'Please enter industry type');
        statusOfSuccess = 'error';
      }
      return statusOfSuccess;
    };


    _onSubmit = async (increment = "step") => {
      // make call to check if cage is valid if so
      if (this.state.processing) return
      this.setState({
        verifying: true,
        processing: true,

      }, async () => {
        switch (this.state.currentFlow) {
          case 'new':
            switch (this.state.step) {
              case 1:
                if ((await this._verifyCage()) !== 'success') {
                  this.setState({ processing: false });
                  return;
                }
                break;
              case 2:
                if ((await this._verifyUser()) !== 'success') {
                  this.setState({ processing: false });
                  return;
                }
                if (!this.state.continueWithoutCage) break;
                await this._getOrgDetailsLists();
                break;
              case 3:
                if (this.state.continueWithoutCage) {
                  switch (this.state.orgStep) {
                    case 1:
                      if ((await this._verifyOrgFields()) !== 'success') {
                        this.setState({ processing: false });
                        return;
                      }
                      break;
                    case 2:
                      if ((await this._verifyOrgDescription()) !== 'success') {
                        this.setState({ processing: false });
                        return;
                      }
                      await this._validateAssociations();
                      break;
                    default:
                      break;
                  }
                  break;
                }
                else {
                  if ((await this._verifyOrgDescription()) !== 'success') {
                    this.setState({ processing: false });
                    return;
                  }
                  break;
                }
              case 4:
                this._finalizeSubmit();
                this.setState({ processing: false });
                return;
              default:
                break;
            }

            break;

          case 'industry':
            switch (this.state.step) {
              case 1:
                break;
              case 2:
                if ((await this._verifyUser()) !== 'success') {
                  this.setState({ processing: false });
                  return;
                }
                if ((await this._verifyCage(true)) !== 'success') {
                  this.setState({ processing: false });
                  return;
                }

                break;

              case 3:
                this._finalizeSubmit();
                this.setState({ processing: false });
                return;

              default:
                break;
            }
            break;

          // case 'gov-without-procurement':
          //   switch (this.state.step) {
          //     case 1:
          //       if ((await this._verifyUser()) !== 'success') {
          //         this.setState({ processing: false });
          //         return;
          //       }
          //       if ((await this._verifyCage(true)) !== 'success') {
          //         this.setState({ processing: false });
          //         return;
          //       }

          //       break;

          //     case 2:
          //       this._finalizeSubmit();
          //       this.setState({ processing: false });
          //       return;

          //     default:
          //       break;
          //   }
          //   break;

          case 'gov':
            switch (this.state.step) {
              case 1:
                if ((await this._verifyCage(true)) !== 'success') {
                  this.setState({ processing: false });
                  return;
                }
                break;

              case 2:
                if ((await this._verifyUser()) !== 'success') {
                  this.setState({ processing: false });
                  return;
                }
                // if ((await this._verifyCage(true)) !== 'success') {
                //   this.setState({ processing: false });
                //   return;
                // }
                break;

              case 3:
                this._finalizeSubmit();
                this.setState({ processing: false });
                return;

              default:
                break;
            }
            break;

          default:
            break;
        }
        this.setState({
          verifying: false,
        });

        switch (increment) {
          case "step":
            this.setState(prevState => ({
              step: prevState.step + 1
            }));
            break;
          case "orgStep":
            this.setState(prevState => ({
              orgStep: prevState.orgStep + 1
            }));
            break;
          default:
            this.setState(prevState => ({
              step: prevState.step + 1
            }));
            break;
        }
        this.setState({
          processing: false,
        });

      });

    };

    _getOrgDetailsLists = async () => {
      try {
        const SAMS = await getSamDataWithoutCageAPI("");
        console.log('=== _getOrgDetailsLists Response ===');
        console.log('Full SAMS response:', SAMS);
        console.log('listsSamDataWithoutCage:', SAMS.listsSamDataWithoutCage);
        const listsData = SAMS && SAMS.listsSamDataWithoutCage ? SAMS.listsSamDataWithoutCage : null;
        const industryAssociations = listsData && listsData.industryAssociationsList ? listsData.industryAssociationsList : null;
        console.log('industryAssociationsList from API:', industryAssociations);
        console.log('industryAssociationsList type:', typeof industryAssociations);
        console.log('industryAssociationsList isArray:', Array.isArray(industryAssociations));
        console.log('industryAssociationsList length:', industryAssociations ? industryAssociations.length : 0);

        if (industryAssociations && industryAssociations.length > 0) {
          console.log('First association item:', industryAssociations[0]);
          console.log('First association keys:', Object.keys(industryAssociations[0] || {}));
        }
        console.log('=== End _getOrgDetailsLists Response ===');

        // Only update lists if we got valid data, otherwise preserve existing state
        const updateData = {
          loadingData: false,
        };

        if (listsData && listsData.industryAssociationsList &&
          Array.isArray(listsData.industryAssociationsList)) {
          updateData.industryAssociationsList = listsData.industryAssociationsList;
        }

        if (listsData && listsData.naicsFoundryCodesList) {
          updateData.naicsFoundryCodesList = listsData.naicsFoundryCodesList;
        }

        if (listsData && listsData.naicsMachineCodesList) {
          updateData.naicsMachineCodesList = listsData.naicsMachineCodesList;
        }

        if (listsData && listsData.naicsForgingCodesList) {
          updateData.naicsForgingCodesList = listsData.naicsForgingCodesList;
        }

        if (listsData && listsData.naicsOthersCodesList) {
          updateData.naicsOthersCodesList = listsData.naicsOthersCodesList;
        }

        if (listsData && listsData.industryTypesList &&
          Array.isArray(listsData.industryTypesList)) {
          updateData.industryTypesList = listsData.industryTypesList;
        }

        this.setState(updateData);
      } catch (error) {
        console.error('Error loading organization data:', error);
        console.error('Error details:', error.message, error.stack);
        // Don't clear existing lists on error, just mark as not loading
        this.setState({
          loadingData: false,
        });
      }
    }

    _validateAssociations = async () => {
      try {
        this.state.organization.email = this.state.emailAddress;
        const response = await Axios.put(`${AssociationUrl}/validate`, this.state.organization);
        this.state.organization.associationValidations = response.data;
        for (let i = 0; i < this.state.organization.associationValidations.length; i++) {
          const association = this.state.organization.associationValidations[i];
          if (association.status !== 'current') {
            // alert(`Industry Association ${association.name} cannot be validated`)
          }
        }
      } catch (error) {
        console.log("Association error:", error);
      }
    }

    render() {
      const {
        counter,
        verifying,
        cageCode,
        emailAddress,
        toastLevel,
        toastMessage,
        step,
        orgStep,
        name,
        selectedPoc,
        phone,
        organization,
        // userExists,
        showToast,
        orgType,
        orgExists,
        steps,
        orgAdmin,
        currentFlow,
        continueWithoutCage,
        continueWithoutRFQ,
        organizationList,
        procurementGroupList,
        industryAssociationsList,
        industryTypesList,
        naicsFoundryCodesList,
        // naicsCastingCodesList,
        naicsMachineCodesList,
        naicsForgingCodesList,
        naicsOthersCodesList,
        reasonRegistration,
        inputProcGrp,
        loadingData,
        finalSubmit,
      } = this.state;
      const pageProps = {
        organizationList,
        procurementGroupList,
        continueWithoutCage,
        continueWithoutRFQ,
        onOrganizationChange: this._onOrganizationChange,
        onCountryChange: this._onCountryChange,
        OnFoundOrganizationChange: this._OnFoundOrganizationChange,
        onProcurementGroupChange: this._onProcurementGroupChange,
        currentFlow,
        counter,
        inputProcGrp,
        verifying,
        handleOk: this._handleOk,
        steps,
        orgType,
        orgAdmin,
        organization,
        cage: cageCode,
        email: emailAddress,
        onChange: this._onChange,
        onSelect: this._onProcurementGroupChange,
        onCancel: this._onCancel,
        onMultiSelectOrganization: this._onMultiSelectOrganization,
        changeOrg: this._changeOrg,
        setRegistatrationFlow: this._setRegistatrationFlow,
        toastLevel,
        toastMessage,
        onSubmit: this._onSubmit,
        step,
        orgStep,
        name,
        phone,
        selectedPoc,
        // userExists,
        showToast,
        orgExists,
        industryAssociationsList,
        industryTypesList,
        naicsFoundryCodesList,
        // naicsCastingCodesList,
        naicsMachineCodesList,
        naicsForgingCodesList,
        naicsOthersCodesList,
        reasonRegistration,
        loadingData,
        closeModalFailedRegistration: this.closeModalFailedRegistration,
        finalSubmit,
      };
      return (
        <RegistrationPage {...pageProps} />
      );
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/Registration/RegistrationHOC.jsx